module.exports = __webpack_public_path__ + "Icono_notificacion_Azul.png";